var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { TextField as MuiTextField } from "@mui/material";
import { useTextUpdateModeField } from "../../hooks/useTextUpdateModeField";
var CommentFieldInput = function (_a) {
    var field = _a.field, element = _a.element, textUpdateMode = _a.textUpdateMode, error = _a.error, errorMessage = _a.errorMessage, isEnabled = _a.isEnabled, fieldMaxLength = _a.fieldMaxLength, autoGrowComment = _a.autoGrowComment;
    var textUpdateModeField = useTextUpdateModeField({
        field: field,
        textUpdateMode: textUpdateMode,
    });
    var fixedRows = typeof element.rows === "number" ? element.rows : 4;
    var rowsProps = autoGrowComment
        ? { minRows: fixedRows }
        : { rows: fixedRows };
    return (_jsx(MuiTextField, __assign({}, field, textUpdateModeField, { fullWidth: true, multiline: true }, rowsProps, { placeholder: element.placeholder, error: error, helperText: _jsxs("span", __assign({ style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
            } }, { children: [_jsx("span", { children: errorMessage }), fieldMaxLength ? (_jsx("span", { children: "".concat(textUpdateModeField.value.length, "/").concat(fieldMaxLength) })) : null] })), disabled: !isEnabled, inputProps: {
            maxLength: fieldMaxLength,
        }, sx: {
            "& .MuiInputBase-inputMultiline": {
                resize: autoGrowComment ? "none" : "vertical",
            },
        } })));
};
export default CommentFieldInput;
